import { useEffect } from 'react';

import { FLY_TO_ZOOM } from './constants';
import type { UseFlyToParams } from './types';

// Imperatively fly the map to a target point whenever the `point` prop
// transitions to a non-null value. The parent controls the trigger cadence:
// pass a fresh `{ lat, lng }` object to fire, then call `onFlew` (fired here
// after `flyTo`) to reset the parent state back to null. This keeps the hook
// stateless and avoids timing hacks. Repeat picks of the same coordinate
// work because the parent always re-nulls between calls.
const useFlyTo = ({ map, onFlew, point }: UseFlyToParams) => {
    useEffect(() => {
        if (!map || !point) {
            return;
        }

        map.flyTo({
            center: [point.lng, point.lat],
            zoom: FLY_TO_ZOOM
        });

        onFlew?.();
    }, [map, point, onFlew]);
};

export default useFlyTo;
